module.exports = __webpack_public_path__ + "static/media/logo.4d58c8f4.svg";


//////////////////
// WEBPACK FOOTER
// ./docs/logo.svg
// module id = 788
// module chunks = 4